export var MemberMaritalStatus;
(function(MemberMaritalStatus) {
    MemberMaritalStatus[/**
     * Not Specified
     */ "NotSpecified"] = "NotSpecified";
    MemberMaritalStatus[/**
     * Single
     */ "Single"] = "Single";
    MemberMaritalStatus[/**
     * Married
     */ "Married"] = "Married";
    MemberMaritalStatus[/**
     * Partnered
     */ "Partnered"] = "Partnered";
    MemberMaritalStatus[/**
     * Divorced
     */ "Divorced"] = "Divorced";
    MemberMaritalStatus[/**
     * Other
     */ "Other"] = "Other";
})(MemberMaritalStatus || (MemberMaritalStatus = {}));

//# sourceMappingURL=member-marital-status.js.map